'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _support = require('helpers/support');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyReward = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    MY_REWARD_LIST: state.voucher.MY_REWARD_LIST
  };
}, {
  resetBooking: bookingActions.resetBooking,
  setDefaultBooking: bookingActions.setDefaultBooking,
  changeShopBeforeBooking: bookingActions.changeShopBeforeBooking,
  showDownloadAppPopup: setupActions.showDownloadAppPopup,
  setPathName: _setup.setPathName
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MyReward, _Component);

  function MyReward() {
    (0, _classCallCheck3.default)(this, MyReward);
    return (0, _possibleConstructorReturn3.default)(this, (MyReward.__proto__ || (0, _getPrototypeOf2.default)(MyReward)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyReward, [{
    key: 'toBookingReward',
    value: function toBookingReward(code) {
      this.props.history.push('/uu-dai-cua-toi/' + code);
      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Clicked Voucher Card from My Reward',
        label: '' + code
      });
    }
  }, {
    key: 'onBooking',
    value: function onBooking(e, item) {
      this.props.showDownloadAppPopup();
      // const { code, shop, service } = item;
      // const {
      //   resetBooking,
      //   setDefaultBooking,
      //   history,
      //   user,
      //   changeShopBeforeBooking,
      // } = this.props;
      // e.stopPropagation();
      // resetBooking();
      // changeShopBeforeBooking(shop, user);
      // const bookingServices = [
      //   { service: service._id, number: 1, name: service.name },
      // ];
      // const submit = { bookingServices, code, shop };
      // setDefaultBooking(submit);
      // history.push(`/dat-lich`);
      // if (user) {
      //   ReactGA.event({
      //     category: 'Promotion',
      //     action: 'Clicked Booking button',
      //     label: `${code}`,
      //   });
      //   ReactGA.event({
      //     category: 'Booking',
      //     action: 'Clicked To Step 1 (General Voucher)',
      //     label: `${shop.name}`,
      //   });
      // } else {
      //   ReactGA.event({
      //     category: 'Promotion',
      //     action: 'Clicked Booking button (not logged in)',
      //     label: `${code}`,
      //   });
      // }
    }
  }, {
    key: 'toLogin',
    value: function toLogin() {
      this.props.setPathName('/uu-dai');
      this.props.history.push('/dang-nhap');
    }
  }, {
    key: 'renderMyReward',
    value: function renderMyReward(item, i) {
      var _this2 = this;

      var styles = require('./LookmeReward.scss');
      var _item$packageService = item.packageService,
          shop = _item$packageService.shop,
          service = _item$packageService.service,
          notSupportOn = _item$packageService.notSupportOn;

      var _item = {
        title: item.campaign.name,
        code: item.code,
        countDown: _support.Helper.distanceTwoDate(item.campaign.limitDate),
        image: item.packageService.image,
        newPrice: item.packageService.displayValue,
        oldPrice: service.price,
        shopName: shop.name,
        isBooking: shop.isBooking,
        address: shop.addressDisplay ? shop.addressDisplay : shop.address,
        isUsed: item.isUsed,
        packId: item.packageService._id,
        shop: shop,
        service: service,
        notSupportOn: notSupportOn
      };
      return _react2.default.createElement(_components.MyVoucherItem, {
        style: styles.voucherItem,
        key: 'voucher_' + i,
        item: _item,
        onPress: function onPress() {
          return _this2.toBookingReward(_item.code);
        },
        onBooking: function onBooking(e) {
          return _this2.onBooking(e, _item);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./LookmeReward.scss');
      var _props = this.props,
          data = _props.MY_REWARD_LIST.data,
          user = _props.user;

      return _react2.default.createElement(
        'div',
        { className: styles.myReward },
        user ? _react2.default.createElement(
          'div',
          { className: '' + styles.listVoucher },
          !!(data && data.length) ? data.map(function (item, i) {
            return _this3.renderMyReward(item, i);
          }) : _react2.default.createElement(
            'div',
            { className: styles.nodata },
            'Hi\u1EC7n t\u1EA1i b\u1EA1n ch\u01B0a c\xF3 khuy\u1EBFn m\xE3i n\xE0o!'
          )
        ) : _react2.default.createElement(
          'div',
          { className: styles.requireLogin },
          'B\u1EA1n c\u1EA7n',
          ' ',
          _react2.default.createElement(
            'span',
            { className: styles.btnLogin, onClick: this.toLogin.bind(this) },
            '\u0111\u0103ng nh\u1EADp'
          ),
          ' ',
          '\u0111\u1EC3 xem th\xF4ng tin n\xE0y'
        )
      );
    }
  }]);
  return MyReward;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  history: _react.PropTypes.object,
  MY_REWARD_LIST: _react.PropTypes.object,
  reward: _react.PropTypes.array,
  resetBooking: _react.PropTypes.func,
  setDefaultBooking: _react.PropTypes.func,
  changeShopBeforeBooking: _react.PropTypes.func,
  setPathName: _react.PropTypes.func,
  showDownloadAppPopup: _react.PropTypes.func
}, _temp)) || _class);
exports.default = MyReward;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/MyReward.js
// module id = 721
// module chunks = 0